document.addEventListener('DOMContentLoaded', ()=>{

    function throttle(func, delay) {
        let timeoutId;
        return function(...args) {
          if (!timeoutId) {
            timeoutId = setTimeout(() => {
              func.apply(this, args);
              timeoutId = null;
            }, delay);
          }
        };
    }


    let scrollTopBtn = document.querySelector('.scroll-top-btn')

    window.addEventListener('scroll', throttle(()=>{
        if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
            scrollTopBtn.style.display = "flex";
        } else {
            scrollTopBtn.style.display = "none";
        }
    },100))

    scrollTopBtn.addEventListener('click', ()=>{
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    })

})